
import formatting from "@/mixins/formatting-mixin";
import { defineComponent } from "vue";
import Tooltip from '@/components/common-components/Tooltip.vue';

export default defineComponent({
  name: "plan-header",
  components: {
    Tooltip
  },
  props: {
    plan: {
      type: Object,
      required: true,
    },
    isMed: {
      required: true,
    },
    isRx: {
      required: true,
    },
    isDental: {
      required: false,
      default: false,
    },
    isIdv: {
      required: false,
      default: false,
    },
    isExtend: {
      required: false,
      default: false,
    },
    isVision: {
      required: false,
      default: false,
    },
    isFocus: {
      required: false,
      default: false,
    },
    isPlanSummary: {
      required: false,
      default: false,
    },
    isRecommended: {
      required: false,
    },
    consumer: {
      type: String,
      required: false,
    },
    isPlanSummaryView: {
      required: false,
      default: false,
    },
    showOtherPlansProductCode: {
      type: Boolean,
      default: false
    },
    forEnrollmentOverview: {
      type: Boolean,
      default: false
    },
    memberexperiencemode: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    enableHoCarryover: {
      type: Boolean,
      default: false
    },
  },
  mixins: [formatting],

  computed: {
    planTypeText() {
      if (this.isExtend) {
        return "Humana Extend Plan";
      }
      if (this.isDental) {
        return "Dental Plan";
      }
      if (this.isVision || this.isFocus) {
        return "Vision Plan";
      }
      if (
        this.plan.basicInformation.productType?.code?.includes("PPO") ||
        this.plan.basicInformation.productType?.code?.includes("HMO") ||
        this.plan.basicInformation.productType?.code?.includes("HMO POS")
      ) {
        return "Medicare Advantage Plan";
      }

      if (this.plan.basicInformation.productType?.code?.includes("PDP")) {
        return "Prescription Drug Plan";
      }

      return "Private Fee for Service";
    },
    coverageTypeCardFiller() {
      return this.isMed
        ? this.isRx
          ? { img: "med-and-drug", text: "Medical & Rx drug coverage" }
          : { img: "medi-clipboard", text: "Medical coverage only" }
        : { img: "rx", text: "Rx drug coverage only" };
    },
    planNameFields() {
      const planName = (this.plan?.basicInformation?.planName).toLowerCase() === 'humana vision plus' ? 'Humana Vision PLUS' : this.plan?.basicInformation?.planName;
      return {
        name: planName,
        contractNumber: this.plan.basicInformation.contractNumber,
      };
    },

    getPlanName() {
      let splitPlanNumber = this.plan?.basicInformation?.id.split("-")
      let segmentNumber = splitPlanNumber[2] !== "000" ? "-" + splitPlanNumber[2] : "";
      let final = this.plan.basicInformation?.productType?.code + " " + splitPlanNumber[0] + "-" + splitPlanNumber[1] + segmentNumber;
      return final;
    },

    planHoaCarryover() {
      return (
          this.enableHoCarryover &&
          this.plan?.benefitsMedicare?.otherBenefits?.isHealthFoodCardsIncluded &&
          this.plan?.benefitsMedicare?.otherBenefits?.healthyOptionsAllowanceAmount
      );
    }
  },
  methods: {
    checkIDVProductTypeCodes() {
      let isDiscountPlan = this.plan?.basicInformation?.individualDentalAndVisionPlans?.isDiscountProduct;
      let displayProductTypeCode = this.plan?.basicInformation?.productType?.code ? this.plan?.basicInformation?.productType?.code : "";
      if(isDiscountPlan && displayProductTypeCode === ""){
        displayProductTypeCode = "Discount Plan";
      }
      if (this.plan?.basicInformation?.productType?.code === "PPO" && this.showOtherPlansProductCode) {
        displayProductTypeCode = "Other Plans";
      }
      return displayProductTypeCode;
    }
  }
});
